import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Auction, Notification} from "domain-models"
import {make, relative, translate} from 'filters'
import _ from 'lodash'
import React from "react"
import {hideAuction, showAuction, updateNotifications} from "redux/actions"
import {store} from "store"
import Modal from "./Modal"
import {connect} from "react-redux"
import {GlobalState} from "../state"
import Trans from './Trans'

type NotificationsModalProps = {
  hideModal: () => void
  auctions: Array<Auction>
}

type NotificationsModalState = {
  showingNotifications: boolean,
  showingAnnouncements: false
}

class NotificationsModal extends React.Component<NotificationsModalProps, NotificationsModalState> {
  constructor(props: NotificationsModalProps) {
    super(props)
    this.state = {
      showingNotifications: true,
      showingAnnouncements: false,
    }
  }

  componentDidMount() {
    this.readNotifications()
  }

  openAuction = async (notification: Notification) => {
    const id = notification.body.auctionId

    let auction = _.find(this.props.auctions)

    if (!auction && id) {
      const {data} = await window.axios.get('/auctions/' + id)
      auction = data
    }

    if (auction) {
      await store.dispatch(hideAuction())
      store.dispatch(showAuction(auction))
    }

    this.props.hideModal()
  }

  readNotifications = async () => {
    await window.axios.get('/notifications-read')
    await updateNotifications()
  }

  render() {
    const header = (
      <div className="px-3 py-2 text-gray-700 font-semibold flex flex-row justify-between items-center">
        <span className='truncate'><Trans>Benachrichtigungen</Trans></span>

        <button onClick={this.props.hideModal} className={"flex border-0 font-semibold text-lg rounded text-gray-600 hover:text-gray-700 px-2 py-1 ml-2"} type="button">
          <Icon icon="times"/>
        </button>
      </div>
    )
    const footer = (
      <div className="flex flex-row justify-end p-2">
        <button onClick={() => this.props.hideModal()} className={"px-2 py-1 border rounded hover:bg-gray-200 text-gray-700 shadow"} type="button">
          <Trans>Schließen</Trans>
        </button>
      </div>
    )
    const body = (
      <div className={"flex flex-col p-3 text-gray-700"}>
        {
          _.get(store.getState(), 'app.notifications.notifications', []).length ?
            <div>
              {_.map(_.get(store.getState(), 'app.notifications.notifications', []), notification => {
                notification.body = _.isString(notification.body) ? JSON.parse(notification.body) : notification.body

                return (
                  <div className="flex flex-row mb-6 cursor-pointer hover:bg-gray-100 " key={notification.id} onClick={() => this.openAuction(notification)}>
                    <div className="flex flex-col w-full">
                      <div className="flex flex-row justify-between">
                        <div className="leading-tight font-semibold">{notification.body.message}</div>

                        <div className="text-gray-500">
                          {relative(notification.created_at)}
                        </div>
                      </div>

                      <div>
                        {make(notification.body.make)} {notification.body.shortDescription}
                      </div>

                      {
                        notification.action_url ?
                          <a href={notification.action_url} className="bg-gray-200 hover:bg-gray-400 px-2 py-1 text-center font-semibold rounded mt-2"><Trans>{notification.action_text}</Trans></a>
                          : null}
                    </div>
                  </div>
                )
              })}
            </div>
            :
            <div className="flex flex-row mb-12">
              {translate('Hey, there aren\'t any ' + (this.state.showingAnnouncements ? 'announcements' : 'notifications') + ' to display. Once there are, they will show up here!')}
            </div>
        }
      </div>
    )
    return (
      <Modal header={header} footer={footer} body={body} align="right" pin={true} classes={" rounded overflow-hidden max-w-sm "}/>
    )
  }
}

export default connect((state: GlobalState) => ({
  auctions: state.auctions.auctions
}))(NotificationsModal)
